/* 农历部分 */
// let weekString = '日一二三四五六'
let cYear, cMonth, cDay

function GetBit (m, n) {
    return (m >> n) & 1
}
function e2c () {
    let CalendarData = ["0xA4B", "0x5164B", "0x6A5", "0x6D4", "0x415B5", "0x2B6", "0x957", "0x2092F", "0x497", "0x60C96", "0xD4A", "0xEA5", "0x50DA9", "0x5AD",
        "0x2B6", "0x3126E", "0x92E", "0x7192D", "0xC95", "0xD4A", "0x61B4A", "0xB55", "0x56A", "0x4155B", "0x25D", "0x92D", "0x2192B", "0xA95", "0x71695", "0x6CA",
        "0xB55", "0x50AB5", "0x4DA", "0xA5B", "0x30A57", "0x52B", "0x8152A", "0xE95", "0x6AA", "0x615AA", "0xAB5", "0x4B6", "0x414AE", "0xA57", "0x526", "0x31D26",
        "0xD95", "0x70B55", "0x56A", "0x96D", "0x5095D", "0x4AD", "0xA4D", "0x41A4D", "0xD25", "0x81AA5", "0xB54", "0xB6A", "0x612DA", "0x95B", "0x49B", "0x41497",
        "0xA4B", "0xA164B", "0x6A5", "0x6D4", "0x615B4", "0xAB6", "0x957", "0x5092F", "0x497", "0x64B", "0x30D4A", "0xEA5", "0x80D65", "0x5AC", "0xAB6", "0x5126D",
        "0x92E", "0xC96", "0x41A95", "0xD4A", "0xDA5", "0x20B55", "0x56A", "0x7155B", "0x25D", "0x92D", "0x5192B", "0xA95", "0xB4A", "0x416AA", "0xAD5", "0x90AB5",
        "0x4BA", "0xA5B", "0x60A57", "0x52B", "0xA93", "0x40E95"]
    let madd = [0,31,59,90,120,151,181,212,243,274,304,334]
    let TheDate = (arguments.length !== 3) ? new Date() : new Date(arguments[0], arguments[1], arguments[2])
    let total, m, n, k
    let isEnd = false
    let tmp = TheDate.getYear()
    if (tmp < 1900) {
        tmp += 1900
    }
    total = (tmp - 1921) * 365 + Math.floor((tmp - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38
    if (TheDate.getYear() % 4 === 0 && TheDate.getMonth() > 1) {
        total++
    }
    for (m = 0; ; m++) {
        k = (CalendarData[m] < 0xfff) ? 11 : 12
        for (n = k; n >= 0; n--) {
            if (total <= 29 + GetBit(CalendarData[m], n)) {
                isEnd = true
                break
            }
            total = total - 29 - GetBit(CalendarData[m], n)
        }
        if (isEnd) break
    }
    cYear = 1921 + m
    cMonth = k - n + 1
    cDay = total
    if (k === 12) {
        if (cMonth === Math.floor(CalendarData[m] / 0x10000) + 1) {
            cMonth = 1 - cMonth
        }
        if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
            cMonth--
        }
    }
}

/**
 * 获取干支纪年
 * [yearZN description]
 * @return {[type]} [description]
 */
function yearZN(){
    let tgString = '甲乙丙丁戊己庚辛壬癸'
    let dzString = '子丑寅卯辰巳午未申酉戌亥'
    let tmp = ''
        tmp += tgString.charAt((cYear - 4) % 10)
        tmp += dzString.charAt((cYear - 4) % 12)
    return tmp;
}

/**
 * 根据年 获取属相
 * [ChineseZodiac description]
 */
function ChineseZodiac(){
    let sx = '鼠牛虎兔龙蛇马羊猴鸡狗猪'
    return sx.charAt((cYear - 4) % 12)
}

/**
 * 获取阴历
 * [GetcDateString description]
 */
function GetcDateString () {
    let numString = '一二三四五六七八九十'
    let monString = '正二三四五六七八九十冬腊'
    let tmp = ''
    if (cMonth < 1) {
        tmp += '(闰)'
        tmp += monString.charAt(-cMonth - 1)
    } else {
        tmp += monString.charAt(cMonth - 1)
    }
    tmp += '月'
    tmp += (cDay < 11) ? '初' : ((cDay < 20) ? '十' : ((cDay < 30) ? '廿' : '三十'))
    if (cDay % 10 !== 0 || cDay === 10) {
        tmp += numString.charAt((cDay - 1) % 10)
    }
    return tmp
}
function GetLunarDay (solarYear, solarMonth, solarDay) {
    // solarYear = solarYear<1900?(1900+solarYear):solarYear
    if (solarYear < 1921 || solarYear > 2020) {
        return ''
    } else {
        solarMonth = (parseInt(solarMonth) > 0) ? (solarMonth - 1) : 11
        e2c(solarYear, solarMonth, solarDay)
        return [yearZN(), ChineseZodiac(), GetcDateString()]
    }
}

/**
 * 获取指定时间的二十四节气
 * [SolarTerm description]
 * @param {[type]} timestemp [description]
 */
function SolarTerm(D) {
    let SolarTermStr = new Array(
        "小寒", "大寒", "立春", "雨水", "惊蛰", "春分",
        "清明", "谷雨", "立夏", "小满", "芒种", "夏至",
        "小暑", "大暑", "立秋", "处暑", "白露", "秋分",
        "寒露", "霜降", "立冬", "小雪", "大雪", "冬至");
    let DifferenceInMonth = new Array(
        1272060, 1275495, 1281180, 1289445, 1299225, 1310355,
        1321560, 1333035, 1342770, 1350855, 1356420, 1359045,
        1358580, 1355055, 1348695, 1340040, 1329630, 1318455,
        1306935, 1297380, 1286865, 1277730, 1274550, 1271556);
    let DifferenceInYear = 31556926;
    let BeginTime = new Date('1901 / 1 / 1');
    BeginTime.setTime(947120460000);
    for (; D.getFullYear() < BeginTime.getFullYear();) {
        BeginTime.setTime(BeginTime.getTime() - DifferenceInYear * 1000);
    }
    for (; D.getFullYear() > BeginTime.getFullYear();) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInYear * 1000);
    }
    for (var M = 0; D.getMonth() > BeginTime.getMonth(); M++) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInMonth[M] * 1000);
    }
    if (D.getDate() > BeginTime.getDate()) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInMonth[M] * 1000);
        M++;
    }
    if (D.getDate() > BeginTime.getDate()) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInMonth[M] * 1000);
        M == 23 ? M = 0 : M++;
    }
    let JQ = "";
    if (D.getDate() == BeginTime.getDate()) {
        JQ += SolarTermStr[M];
    }
    return JQ;
}

/**
 * 获取指定日期的中文星期
 * [dateWeekFN description]
 * @param  {[type]} timestemp [description]
 * @return {[type]}           [description]
 */
function dateWeekFN(D){
    function InitArray () {
        this.length = arguments.length
        for (let i = 0; i < this.length; i++) this[i + 1] = arguments[i]
    }
    let d = new InitArray('星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六')
    return d[D.getDay() + 1];
}

/**
 * 获取中文年月日
 * [dateDFN description]
 * @param  {[type]} timestemp [description]
 * @return {[type]}           [description]
 */
function dateDFN(D){
    return (D.getFullYear() + '年' + (D.getMonth() + 1) + '月' + D.getDate() + '日')
}

/**
 * 获取指定日期的节日
 * [dateFestivalFN description]
 * @param  {[type]} timestemp [description]
 * @return {[type]}           [description]
 */
function dateFestivalFN(m, d){
    let dateString = '';
    if ((m === 1) && (d === 1)) dateString += '元旦'
    if ((m === 3) && (d === 12)) dateString += '植树节'
    if ((m === 4) && (d === 5)) dateString += '清明节'
    if ((m === 5) && (d === 1)) dateString += '国际劳动节'
    if ((m === 5) && (d === 4)) dateString += '青年节'
    if ((m === 6) && (d === 1)) dateString += '国际儿童节'
    if ((m === 8) && (d === 1)) dateString += '建军节'
    if ((m === 8) && (d === 16)) dateString += '七夕情人节'
    if ((m === 10) && (d === 1)) dateString += '国庆节/国际音乐节/国际老人节'
    if ((m === 12) && (d === 24)) dateString += '平安夜'
    if ((m === 12) && (d === 25)) dateString += '圣诞节'
    return dateString;
}

const showCalendar = function (timestemp) {

    let D = new Date(timestemp)
    let yy = D.getFullYear()
    let mm = D.getMonth() + 1
    let dd = D.getDate()
    // let ww = D.getDay()
    // let ss = parseInt(D.getTime() / 1000)
    if (yy < 100) yy = '19' + yy
    // dateString += GetLunarDay(yy, mm, dd)
 
    let d = dateDFN(D) + '<' + GetLunarDay(yy, mm, dd)[0] + ' (' + GetLunarDay(yy, mm, dd)[1] + ')年 ' + GetLunarDay(yy, mm, dd)[2] + '> ' + dateWeekFN(D) + ' ' + SolarTerm(D) + ' ' + dateFestivalFN(mm, dd)

    let ChineseFestival = [
        {
            day:'正月初一',
            festival:'春节'
        },
        {
            day:'正月十五',
            festival:'元宵节'
        },
        {
            day:'二月初二',
            festival:'龙抬头/社日节'
        },
        {
            day:'五月初五',
            festival:'端午节'
        },
        {
            day:'七月初七',
            festival:'七夕节'
        },
        {
            day:'七月十五',
            festival:'七月半(中元节/鬼节)'
        },
        {
            day:'八月十五',
            festival:'中秋节'
        },
        {
            day:'九月初九',
            festival:'重阳节'
        },
        {
            day:'腊月二十三',
            festival:'小年'
        },
        {
            day:'腊月三十',
            festival:'除夕'
        },
    ]
    d += ' ' + ChineseFestival.find(list => list.day === GetLunarDay(yy, mm, dd)[2]).festival;

    let d_ = {
        Date:dateDFN(D),
        yearZN:GetLunarDay(yy, mm, dd)[0],
        ChineseZodiac:GetLunarDay(yy, mm, dd)[1],
        Calendar:GetLunarDay(yy, mm, dd)[2],
        Week:dateWeekFN(D),
        SolarTerm:SolarTerm(D) || '',
        Festival:dateFestivalFN(mm, dd) || '',
        ChineseFestival:ChineseFestival.find(list => list.day === GetLunarDay(yy, mm, dd)[2]).festival || ''
    }
    console.log(d_)

    return d;
}


export default showCalendar


// WEBPACK FOOTER //
// ./src/assets/js-plug-in-unit/LunarCalendar.js